import type { AdminLook, LookMode } from "./looks";

/**
 * The look + mode the theme was last built with (set by `useMode`). Read by
 * code that runs outside a component — `tokens(mode)` at old call sites,
 * calendar event colours — so it follows the look without a hook.
 */
let active: { look: AdminLook; mode: LookMode } = { look: "classic", mode: "light" };

export function setActiveLook(look: AdminLook, mode: LookMode = active.mode): void {
  active = { look, mode };
}

export const getActiveLook = (): AdminLook => active.look;
export const getActiveMode = (): LookMode => active.mode;
